import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { eapiClient } from '../../../../../../restClient';

import { accordionFieldsMap } from '../../../../ProductRequests/CaptureProductAchCredit/mappingFile';

import { Translations, createDisplayString, getRandomNumber, checkJson } from '../../../../../../utils';

import './styles.css';

const CHK_BOX = 'CHECKED';
const UNCHK_BOX = 'UNCHECKED';

class AchAccordion extends Component {
  constructor(props) {
    super(props);
    this.state = {
      accordionData: this.props.accordionData,
      accordionAemData: this.props.accordionAemData,
      taxonomyData: this.props.taxonomyData !== undefined && this.props.taxonomyData.responseData !== undefined ? this.props.taxonomyData.responseData.classificationNodes : [],
      productReferenceObjects: this.props.productReferenceObjects || []
    }
  }



  componentWillReceiveProps(nextProps) {
    if (JSON.stringify(this.props.accordionData) !== JSON.stringify(nextProps.accordionData)) {
      this.setState({
        accordionData: nextProps.accordionData,
        accordionAemData: nextProps.accordionAemData,
        taxonomyData: this.props.taxonomyData.responseData.classificationNodes,
        productReferenceObjects: this.props.productReferenceObjects || []
      })
    }

    if (this.props.lang.currentLang.lang !== nextProps.lang.currentLang.lang) {
      this.setTranslatedDataFromTaxonomy();
    }
  }

  setTranslatedDataFromTaxonomy = () => {
    eapiClient(Translations(this.props.title.par.aemform_creditTransferSpecific.creditTaxonomy, this.props.lang.currentLang.lang, this.props.lang.translatedData))
      .then(({ data }) => {
        this.setState({
          taxonomyData: data.responseData.classificationNodes
        })
      });
  }

  renderAccordionHeading = (accordionName) => {
    let accordionKey = undefined;
    for (let [accordionData] of Object.entries(this.props.title.par)) {
      if (accordionData.startsWith('aemform_')) {
        if (accordionName === this.props.title.par[accordionData].name) {
          accordionKey = this.props.title.par[accordionData].title;
          return (
            <div className="gdocs-ach-credit-accordion-heading-main-div">
              {(Translations(accordionKey, this.props.lang.currentLang.lang, this.props.lang.translatedData)).toUpperCase()}
            </div>
          )
        }
      }
    }
  }

  renderKeyValuePair = (displayKey, displayValue = undefined, subItem = false, checkBoxItem = undefined, tooltip = undefined, displayId = undefined, para1, para2) => {
    if (displayKey && !displayValue && !subItem && !checkBoxItem) {
      return (
        <p key={displayKey + getRandomNumber(9999)} className="gdocs-preview-heading-text-main-div">{displayKey}</p>
      )
    } else if (displayKey && !displayValue && !subItem && checkBoxItem) {
      return (
        <div key={displayKey + getRandomNumber(9999)} className="gdocs-preview-heading-text-main-div" style={{ display: 'flex', alignItems: "center" }}>
          <span style={{ marginRight: '1rem' }}><i className={`icon ${checkBoxItem === CHK_BOX ? 'icon-ballot-box-with-check' : 'icon-ballot-box'} gdocs-valign-middle hintText-icon`}></i></span>
          <span>{displayKey}</span>
        </div>
      )
    }
    else if (!(this.props.addDetails.paymentType === "newindirect" || this.props.addDetails.paymentType === "transferofsponsorshipindirect") && (displayKey === "Pin Pad Device" || displayValue === "Pin Pad Device")) {
      return (
        displayValue !== "Value NA" ?
          <dl className="dl-horizontal-achCredit" style={{ flexDirection: "column" }} key={displayValue + getRandomNumber(9999)}>
            <dt>{displayKey ? displayKey : displayValue}</dt>
            <dt style={{ width: '100%', display: 'flex', alignItems: "center" }}>
              <span style={{ marginRight: '1rem' }}><i className={`icon ${displayKey === "Pin Pad Device" ? 'icon-ballot-box-with-check' : 'icon-ballot-box'} gdocs-valign-middle hintText-icon`}></i>
              </span>
              <span>{displayKey === "Pin Pad Device" ? displayValue : this.state.taxonomyData.find(el => el.name === displayValue) && this.state.taxonomyData.find(el => el.name === displayValue).associations[0].name}</span>
            </dt>
          </dl>
          : null
      )
    }
    else if (displayKey && !displayValue && subItem) {
      //Subitem is present for children checkboxes e.g AutoPayElectronic -> [hsbcConnect,hsbcNet]
      return (
        <p key={displayId}>
          <span>
            <i className="icon icon-chevron-right-small gdocs-valign-middle gdocs-mleft-5 hintText-icon">
            </i>
          </span>
          {displayKey}
        </p>
      )
    } else {
      if (!displayKey) {
        if (checkBoxItem) {
          return (
            <dl className="dl-horizontal-achCredit" key={displayValue + getRandomNumber(9999)}>
              <dt style={{ width: '100%', display: 'flex', alignItems: "center" }}>
                <span style={{ marginRight: '1rem' }}><i className={`icon ${checkBoxItem === CHK_BOX ? 'icon-ballot-box-with-check' : 'icon-ballot-box'} gdocs-valign-middle hintText-icon`}></i>
                </span>
                <span>{displayValue}</span>
                {
                  displayValue === "N/A completed under SUN" && (this.state.accordionData && this.state.accordionData.naCompletedSUN) ?
                    <span className='gdocs-naCompletedSUN'><b>{this.state.accordionData.naCompletedSUN}</b></span> : null
                }
              </dt>
            </dl>
          )
        } else {
          return (
            <dl className="dl-horizontal-achCredit" key={displayValue + getRandomNumber(9999)}>
              <dt style={{ width: '100%' }}>{displayValue}</dt>
            </dl>
          )
        }

      }
      else {
        let submissionOfTestDataJsx = null

        if (para1 && para2) {
          submissionOfTestDataJsx = (
            <dt className="gdocs-width-100">
              <div >
                {para1}
              </div>
              <div >
                {para2}
              </div>
            </dt>)
        } else if (para1 || para2) {
          submissionOfTestDataJsx = <div style={{ marginTop: '.25rem' }} className='radio-button-main-div'>{Translations(para1 || para2, this.lang, this.translatedData)}</div>
        }

        return (
          (displayKey === "Will test data be submitted?" && displayValue === "Yes") ?
            <dl className="dl-horizontal-achCredit gdocs-display-flex-column" key={displayKey + getRandomNumber(9999)}>
              <div>
                <dt className={displayKey === "Organisation ID (optional)" && "gdocs-width-auto"}>{displayKey}</dt>
                {displayKey === "Organisation ID (optional)" && tooltip ?
                  <dt style={{ width: 'auto', marginRight: '1rem' }}>{tooltip}</dt>
                  : null
                }
                <dd>{typeof displayValue === "boolean" ? displayValue ? "Yes" : "No"
                  : displayValue}
                </dd>
              </div>
              {submissionOfTestDataJsx}
            </dl>
            :
            <dl className="dl-horizontal-achCredit" key={displayKey + getRandomNumber(9999)}>
              <dt className={displayKey === "Organisation ID (optional)" && "gdocs-width-auto"}>{displayKey}</dt>
              {displayKey === "Organisation ID (optional)" && tooltip ?
                <dt style={{ width: 'auto', marginRight: '1rem' }}>{tooltip}</dt>
                : null
              }
              <dd>{typeof displayValue === "boolean" ? displayValue ? "Yes" : "No"
                : displayValue}</dd>
            </dl>
        )
      }
    }

  }

  getStaticText(item) {
    if (item['text1'] !== undefined) {
      if (item['text2'] !== undefined) {
        return [item['text1'], item['text2']]
      }
      return item['text1']
    }
  }

  getLabelText(labelKey) {
    if (labelKey !== undefined && labelKey.length > 1) {
      var text = [Translations(labelKey[0], this.props.lang.currentLang.lang, this.props.lang.translatedData), Translations(labelKey[1], this.props.lang.currentLang.lang, this.props.lang.translatedData)]

      return text.join(" ")
    }

  }

  getLabelFromAemData = (fieldName) => {
    if (fieldName.split('-').length > 1) {
      //In case the field is part of aggregate form box components,e.g. 'aggregateFromBoxName-ComponentName'

    } else {
      //When field is a simple field
      //In case the field is a dropdown also return the display key array, e.g. [["accountType.name","account.country.name"],["account.branch"]]
      let labelKey = this.state.accordionAemData[fieldName]['label'] || this.state.accordionAemData[fieldName]['title'] || this.state.accordionAemData[fieldName]['heading'] || this.getStaticText(this.state.accordionAemData[fieldName]) || undefined;
      let dropDownDisplayKey = !fieldName.startsWith('guideradiobutton_') ? (this.state.accordionAemData[fieldName]['options'] || undefined) : undefined;

      let label = labelKey ? Array.isArray(labelKey) ? this.getLabelText(labelKey) : Translations(labelKey, this.props.lang.currentLang.lang, this.props.lang.translatedData) : 'Field label not found';
      let displayKey = dropDownDisplayKey ? JSON.parse(Translations(dropDownDisplayKey, this.props.lang.currentLang.lang, this.props.lang.translatedData)) : undefined;


      if (fieldName === 'guidetextbox_cin') {
        label = ''
        displayKey = ''
      }
      let fieldLabelObject = {
        label,
        displayKey
      }
      if (this.state.accordionAemData[fieldName]['helpText']) {
        fieldLabelObject.helpText = Translations(this.state.accordionAemData[fieldName]['helpText'], this.props.lang.currentLang.lang, this.props.lang.translatedData)
      }
      if (this.state.accordionAemData[fieldName]['para1']) {
        fieldLabelObject.para1 = Translations(this.state.accordionAemData[fieldName]['para1'], this.props.lang.currentLang.lang, this.props.lang.translatedData)
      }
      if (this.state.accordionAemData[fieldName]['para2']) {
        fieldLabelObject.para2 = Translations(this.state.accordionAemData[fieldName]['para2'], this.props.lang.currentLang.lang, this.props.lang.translatedData)
      }

      return fieldLabelObject;
    }
  }

  getValueFromAccordionData = (currentValue, _displayKey = undefined) => {
    if ((typeof currentValue === 'string') && (currentValue.startsWith('urn:uuid:'))) {
      //This is an id referring to an object in the productReferenceObjects
      let _objectForCurrentId = this.state.productReferenceObjects.filter(refObject => refObject.id === currentValue);
      if (_objectForCurrentId && _objectForCurrentId.length === 1) {
        return (
          <div dangerouslySetInnerHTML={createDisplayString(_objectForCurrentId[0], _displayKey)} />
        )
      } else {
        //In case duplicate id exists or id is not found in ACH product data, id should be returned for display.
        return currentValue;
      }
    } else if ((typeof currentValue === 'object')) {
      if (currentValue instanceof Array) {
        return currentValue;
      } else {
        return currentValue.name || 'Value NA';
      }
    } else {
      return currentValue;
    }
  }

  getLabelFromTaxonomy = (parentChain, child, taxonomyData) => {
    let _taxonomyData = taxonomyData;
    let parentChainItems = parentChain.split('-');
    let itemLable = {};
    for (let item of _taxonomyData) {
      let splitItemId = item.id.split(':')
      if (splitItemId[splitItemId.length - 2] === parentChainItems[0]) {
        if (parentChainItems.length > 1) {
          parentChainItems = parentChainItems.splice(1, parentChainItems.length - 1);
          parentChain = parentChainItems.join('-');
          itemLable = { ...this.getLabelFromTaxonomy(parentChain, child, item.associations) };
        } else {
          if (parentChainItems[0] === child) {
            itemLable.name = item.name || undefined;
            itemLable.value = item.id || undefined;
            itemLable.tooltip = item.tooltip || undefined;
          } else {
            let _associationsArray = item.associations;
            for (let associateItem of _associationsArray) {
              let splitAssociateItemId = associateItem.id.split(':');
              if (splitAssociateItemId[splitAssociateItemId.length - 2] === child) {
                itemLable.name = associateItem.name || undefined;
                itemLable.value = associateItem.id || undefined;
                itemLable.tooltip = associateItem.tooltip || undefined;
                break;
              }
            }
          }
        }
        if (Object.keys(itemLable).length > 1) {
          break;
        }
      }
    }
    return itemLable;
  }

  renderGroupCheckBoxes = (grpChkBoxAemData, grpChkBoxData) => {
    let initTaxonomyData = this.state.taxonomyData;
    let groupCheckBoxHeading = this.getLabelFromTaxonomy(grpChkBoxAemData.name, grpChkBoxAemData.name, initTaxonomyData);
    groupCheckBoxHeading = groupCheckBoxHeading.name || 'Checkbox Title';
    let _groupCheckBoxContentJsx = grpChkBoxData.map(chkBox => {
      let splitChkBoxId = chkBox.id.split(':');
      if (splitChkBoxId[splitChkBoxId.length - 2] !== 'all') {
        return (
          <div key={chkBox.id} className="gdocs-group-checkbox-single-checkbox-main-div">
            {chkBox.name}
          </div>
        )
      }

    }).filter(item => item);

    let groupCheckBoxContent = (
      <div className="gdocs-group-checkbox-components-main-div">
        {_groupCheckBoxContentJsx}
      </div>
    );

    return (
      <div key={`gdocs-group-checkbox-${getRandomNumber(9999)}`} className="gdocs-group-checkbox-preview-main-div">
        <div className="gdocs-group-checkbox-label-main-div">
          {groupCheckBoxHeading}
        </div>
        {groupCheckBoxContent}
      </div>
    );

  }

  getAggregateFormComponentsWithLabel = (aggFormName) => {
    let componentsKey = this.state.accordionAemData[aggFormName]['components'] || undefined;
    let aggregateFormName = this.state.accordionAemData[aggFormName]['name'] ? Translations(this.state.accordionAemData[aggFormName]['name'], this.props.lang.currentLang.lang, this.props.lang.translatedData) : undefined;
    let aggregateFormTitle = this.state.accordionAemData[aggFormName]['title'] && this.state.accordionAemData[aggFormName]['title'].trim() !== '' ? Translations(this.state.accordionAemData[aggFormName]['title'], this.props.lang.currentLang.lang, this.props.lang.translatedData) : undefined;
    let aggFormComponents = [];
    let _formComponents;
    if (componentsKey) {
      _formComponents = JSON.parse(Translations(componentsKey, this.props.lang.currentLang.lang, this.props.lang.translatedData) || JSON.stringify(componentsKey));
    } else {
      _formComponents = [];
    }

    //Get the individual component label and pass it as object in an array to the calling function;
    let _labelKey, label, name, _dropDownDisplayKey, displayKey, fieldType, inputPrefix;
    for (let component of _formComponents) {
      if (component.fieldType === 'aggregateForm') {
        name = component.name;
        fieldType = component.fieldType || undefined;
        _labelKey = component.label || component.title || undefined;
        label = _labelKey ? Translations(_labelKey, this.props.lang.currentLang.lang, this.props.lang.translatedData) : undefined;

        let innerAggFormComp = [];
        let _inner_agg_formComponents = JSON.parse(Translations(component.components, this.props.lang.currentLang.lang, this.props.lang.translatedData));
        for (let inner_component of _inner_agg_formComponents) {
          let name = inner_component.name;
          let fieldType = inner_component.fieldType || undefined;
          let inputPrefix = inner_component.inputPrefix || undefined;

          let _inner_labelKey = inner_component.label || inner_component.title || undefined;
          let label = _inner_labelKey ? Translations(_inner_labelKey, this.props.lang.currentLang.lang, this.props.lang.translatedData) : 'Field label not found';

          let _inner_dropDownDisplayKey = inner_component.options || undefined;
          let displayKey = _inner_dropDownDisplayKey ? JSON.parse(Translations(_inner_dropDownDisplayKey, this.props.lang.currentLang.lang, this.props.lang.translatedData)) : undefined;

          let inner_prepareLabelObject = {
            name,
            label,
            displayKey,
            fieldType,
            inputPrefix
          };

          innerAggFormComp.push(inner_prepareLabelObject)

        }
        let finalAggBoxObj = {
          name,
          fieldType,
          label,
          ['components']: [...innerAggFormComp]
        }
        aggFormComponents.push(finalAggBoxObj);
      } else {
        name = component.name;
        fieldType = component.fieldType || undefined;
        inputPrefix = component.inputPrefix || undefined;
        if (component.fieldType === 'groupCheckBox') {
          _labelKey = this.getLabelFromTaxonomy(component.name, component.name, this.state.taxonomyData);
          label = _labelKey.name;
        } else {
          _labelKey = component.label || component.title || undefined;
          label = _labelKey ? Translations(_labelKey, this.props.lang.currentLang.lang, this.props.lang.translatedData) : 'Field label not found';
        }

        _dropDownDisplayKey = component.options || undefined;

        displayKey = _dropDownDisplayKey ? checkJson(Translations(_dropDownDisplayKey, this.props.lang.currentLang.lang, this.props.lang.translatedData)) : undefined;

        let prepareLabelObject = {
          name,
          label,
          displayKey,
          fieldType,
          inputPrefix
        };
        aggFormComponents.push(prepareLabelObject);
      }
    }

    let prepareAggregateBoxObject = {
      aggregateFormName,
      aggregateFormTitle,
      aggFormComponents
    }
    return prepareAggregateBoxObject;
  }

  renderAggregateFormComponent = (aggBoxTitle = '', aggBoxComponents, aggBoxData = [], aggBoxName) => {
    let _partialAggBoxJsx = [];
    let _aggBoxEnclosingDiv;
    if (aggBoxTitle && aggBoxTitle.trim !== "") {
      _partialAggBoxJsx.push(this.renderKeyValuePair(aggBoxTitle));
    }

    let _aggBoxFieldsJsx = [];
    if (aggBoxData.length > 0) {
      for (let i = 0; i < aggBoxData.length; i++) {
        //If the typeof aggregate box data is a string it is guranteed that the aggregate box has only one component
        if (typeof aggBoxData[i] === 'string') {
          for (let comp of aggBoxComponents) {
            if (aggBoxData[i]) {
              let _displayKey = comp.displayKey || undefined;
              let componentValue = this.getValueFromAccordionData(aggBoxData[i], _displayKey) || ' ';
              _aggBoxFieldsJsx.push(this.renderKeyValuePair(`${comp.label}${(i >= 0) ? ` ${i + 1}` : ''}`, componentValue));
            }
          }
          if (i < aggBoxData.length && i !== aggBoxData.length - 1) {
            _aggBoxFieldsJsx.push(<hr key={`separatorKey${i}-${getRandomNumber(9999)}`} className="gdocs-preview-aggregate-single-component-separator" />);
          }
        } else {
          //If aggregate box data type is object
          let compIdx = 0;
          for (let comp of aggBoxComponents) {
            if (aggBoxData[i][comp.name] || typeof aggBoxData[i][comp.name] === "boolean") {
              let _displayKey = comp.displayKey || undefined;
              let componentValue = this.getValueFromAccordionData(aggBoxData[i][comp.name], _displayKey);
              if (comp.fieldType === 'aggregateForm') {
                _aggBoxFieldsJsx.push(...this.renderAggregateFormComponent(comp.label, comp.components, aggBoxData[i][comp.name], comp.name))
              } else {
                if (comp.fieldType === 'groupCheckBox' && ((componentValue instanceof Array && componentValue.length > 0) || !componentValue)) {
                  if (!componentValue) {
                    componentValue = [];
                  }
                  _aggBoxFieldsJsx.push(this.renderGroupCheckBoxes(comp, componentValue));
                } else {
                  if (!componentValue) {
                    componentValue = comp.name === "bureauOnYourBehalf" && typeof aggBoxData[i][comp.name] === 'boolean' ? aggBoxData[i][comp.name] ? "Yes" : "No" : ' ';
                  }
                  _aggBoxFieldsJsx.push(this.renderKeyValuePair(`${comp.label}${(i >= 0) && (comp.mandatory || compIdx == 0) ? ` ${i + 1}` : ''}`, componentValue));
                }
              }
              compIdx++;
            }
            else if (aggBoxName === "bureauOnYourBehalfReports") {
              if (aggBoxData[i].name === comp["label"]) {
                let _displayKey = comp.displayKey || undefined;
                let componentValue = this.getValueFromAccordionData(aggBoxData[i].name, _displayKey);
                if (!componentValue) {
                  componentValue = ' ';
                }
                _aggBoxFieldsJsx.push(this.renderKeyValuePair(comp.label, undefined, undefined, "CHECKED"));
              }
            }
            else if (!(this.props.addDetails.paymentType === "newindirect" || this.props.addDetails.paymentType === "transferofsponsorshipindirect") && aggBoxName === "primaryContactDetails" && comp["name"] === "pinPadDevice" && aggBoxData[i].securityId) {
              let _displayKey = comp.displayKey || undefined;
              let componentValue = this.getValueFromAccordionData(aggBoxData[i].name, _displayKey);
              if (!componentValue) {
                componentValue = ' ';
              }
              _aggBoxFieldsJsx.push(this.renderKeyValuePair(undefined, comp.label, undefined, aggBoxData[i][comp["name"]] ? CHK_BOX : UNCHK_BOX));
            }
          }
          if (i < aggBoxData.length && i !== aggBoxData.length - 1) {
            _aggBoxFieldsJsx.push(<hr key={'aggregate-box-separator-' + i + '-' + getRandomNumber(9999)} className="gdocs-preview-aggregate-multi-component-separator" />);
          }
        }
      }
      _aggBoxEnclosingDiv = (
        <div className="aggregate-box-enclosing-main-div" key={'aggregate-form-box-' + `${aggBoxName}-` + getRandomNumber(9999)}>
          {_aggBoxFieldsJsx}
        </div>
      );
      _partialAggBoxJsx.push(_aggBoxEnclosingDiv)
    } else if (typeof aggBoxData === 'object' && !(aggBoxData instanceof Array)) {
      //This case is applicable to firstparty and secondParty narrative in non-UK payment types and reversalAccount of HK
      let ctr = 0;
      if (Object.keys(aggBoxData).length > 0) {
        for (let comp of aggBoxComponents) {
          if (aggBoxData[comp.name]) {
            let _displayKey = comp.displayKey || undefined;
            let displayLabel = comp.label;
            if (aggBoxName === 'firstParty' || aggBoxName === 'secondParty') {
              displayLabel = ' ';
              if (ctr === 0) {
                displayLabel = comp.label || 'Field Label Loading'
              }
            }
            let componentValue = this.getValueFromAccordionData(aggBoxData[comp.name], _displayKey);

            if (comp.fieldType === 'groupCheckBox' && componentValue instanceof Array && componentValue.length > 0) {
              _aggBoxFieldsJsx.push(this.renderGroupCheckBoxes(comp, componentValue));
            } else {
              let _displayVal;
              if (comp.inputPrefix) {
                _displayVal = `(${comp.inputPrefix}) ${componentValue}`;
              } else {
                _displayVal = componentValue;
              }
              _aggBoxFieldsJsx.push(this.renderKeyValuePair(displayLabel, _displayVal));
            }
            ctr++;
          }
        }
      }
      _aggBoxEnclosingDiv = (
        <div key={'aggregate-form-box-' + `${aggBoxName}-` + getRandomNumber(9999)}>
          {_aggBoxFieldsJsx}
        </div>
      );
      _partialAggBoxJsx.push(_aggBoxEnclosingDiv)
    }

    return _partialAggBoxJsx;
  }

  renderAccordionFields = (accordionFields, formData = this.props.accordionData) => {
    let _accordionFieldsJsx = [];
    for (let item of accordionFields) {
      switch (typeof item) {
        case 'object': {
          if (item instanceof Array) {
            _accordionFieldsJsx.push(...this.renderAccordionFields(item, formData));
          } else {
            for (let [itemKey, itemValue] of item.entries()) {
              if (itemKey.startsWith('static_text')) {
                _accordionFieldsJsx.push(this.renderKeyValuePair(itemValue.split('$')[0]));
              } else {
                let splitItemKey = itemKey.split(':');
                if (splitItemKey.length > 1) {

                } else {

                }
                _accordionFieldsJsx.push(...this.renderAccordionFields([itemKey, ...itemValue], formData));
              }
            }
          }
          break;
        }
        case 'string': {
          let splitItem = item.split(':');
          if (splitItem.length > 1) {
            //for paymentTypes, radio button, check boxes
            //access state accordion data -> this.state.accordionData
            //Check for -(hyphen) separated parents for taxonomy hirearchy
            let splitForChild = splitItem[1].split('_');
            let _initTaxonomyData = this.state.taxonomyData;
            let itemLable = this.getLabelFromTaxonomy(splitItem[0], splitForChild[1], _initTaxonomyData);
            if (splitForChild[0].startsWith('guidecheckbox')) {
              let accordionFieldValue;
              if (splitForChild[1] === 'hsbcNet' || splitForChild[1] === 'hsbcConnect' || splitForChild[1] === 'postCourier') {
                accordionFieldValue = formData['selectedDeliveryMethods'] || undefined;
              } else if (splitForChild[1] === 'cannedReport' || splitForChild[1] === 'dataFeedReport') {
                accordionFieldValue = formData['reportDeliveryAndFormat'] || undefined;
              } else if (splitForChild[1] === 'txt' || splitForChild[1] === 'xls') {
                accordionFieldValue = (formData['reportDeliveryAndFormat'] && formData['reportDeliveryAndFormat'].length > 0 ? formData['reportDeliveryAndFormat'][0]['reportFormat'] : undefined) || undefined;
              } else {
                accordionFieldValue = formData[splitItem[0]] || undefined;
              }
              if (accordionFieldValue) {
                if (typeof accordionFieldValue === 'object' && accordionFieldValue instanceof Array) {
                  let dataIdx;
                  accordionFieldValue = accordionFieldValue.filter((checkBoxItem, idx) => {
                    let splitCheckBox;
                    if (splitItem[0] === 'paymentTypes') {
                      //Special handling for payment types of non-UK countries
                      splitCheckBox = checkBoxItem.paymentType.value.split(':');
                    } else if (splitItem[0] === 'submissionMethods') {
                      splitCheckBox = checkBoxItem.submissionMethod.value.split(':');
                    } else if (splitItem[0] === 'reportNames') {
                      splitCheckBox = checkBoxItem.reportName.value.split(':');
                    } else if (splitItem[0] === 'reportType') {
                      splitCheckBox = checkBoxItem.reportType.value.split(':');
                    } else {
                      splitCheckBox = checkBoxItem.value.split(':');
                    }
                    if (splitCheckBox[splitCheckBox.length - 2] === splitForChild[1]) {
                      dataIdx = idx;
                      return checkBoxItem;
                    }
                    if (splitCheckBox[splitCheckBox.length - 2] === 'all' || splitCheckBox[splitCheckBox.length - 2] === 'liveInputReport' || splitCheckBox[splitCheckBox.length - 2] === 'arucs' || splitCheckBox[splitCheckBox.length - 2] === 'msgTestReport' || splitCheckBox[splitCheckBox.length - 2] === 'auddis' ||
                      splitCheckBox[splitCheckBox.length - 2] === 'awacs' || splitCheckBox[splitCheckBox.length - 2] === 'testInputReport' || splitCheckBox[splitCheckBox.length - 2] === 'arudd' || splitCheckBox[splitCheckBox.length - 2] === 'addacs') {
                      dataIdx = idx;
                      return checkBoxItem;
                    }
                  });

                  if (accordionFieldValue && accordionFieldValue.length === 1 && splitItem[0] !== 'bureauOnYourBehalfReports') {
                    if (splitItem[0] === 'paymentTypes' || splitItem[0] === 'submissionMethods' || splitItem[0] === 'reportNames' || splitItem[0] === 'reportType') {
                      if (splitItem[0] === 'paymentTypes') {
                        _accordionFieldsJsx.push(this.renderKeyValuePair(itemLable.name.toUpperCase(), undefined, undefined, CHK_BOX, itemLable.tooltip, itemLable.value));
                      } else {
                        _accordionFieldsJsx.push(this.renderKeyValuePair(itemLable.name, undefined, undefined, CHK_BOX, itemLable.tooltip, itemLable.value));
                      }
                      if (splitItem[0] === 'reportType') {
                        _accordionFieldsJsx.push(...this.renderAccordionFields(accordionFields.slice(1, accordionFields.length), formData['reportDeliveryAndFormat'][dataIdx]));
                      } else {
                        // _accordionFieldsJsx.push(<div className="aggregate-box-enclosing-main-div">);
                        _accordionFieldsJsx.push(...this.renderAccordionFields(accordionFields.slice(1, accordionFields.length), formData[splitItem[0]][dataIdx]));
                        // _accordionFieldsJsx.push(</div>);
                      }
                      accordionFields.length = 1;//Resetting the array length to prevent other fields in original array from redundant rendering
                    } else {
                      if (splitItem[0].split('-').length > 1) {
                        //Case is specifically for sub-checkboxes, e.g. AutoPayElectronic -> [hsbcNet,hsbcConnect] where 3rd argument for renderKeyValuePair fn. is true
                        _accordionFieldsJsx.push(this.renderKeyValuePair(itemLable.name, undefined, true, undefined, itemLable.tooltip, itemLable.value));
                      } else {
                        _accordionFieldsJsx.push(this.renderKeyValuePair(undefined, itemLable.name, undefined, CHK_BOX, itemLable.tooltip, itemLable.value));
                      }
                    }
                  } else {
                    //If the corresponding value is not found then chilren should not be rendered. Setting length to 1 exits the current loop.
                    //In some specific cases other items in the array needs to checked before breaking the loop hence the below condition.
                    //If you can think of better approach feel free to code in but do test!
                    if (splitItem[0] === 'reportType') {
                      _accordionFieldsJsx.push(this.renderKeyValuePair(undefined, itemLable.name, undefined, UNCHK_BOX, itemLable.tooltip, itemLable.value));
                    }
                    if (splitItem[0] === 'bureauOnYourBehalfReports') {
                      for (item of accordionFieldValue) {
                        _accordionFieldsJsx.push(this.renderKeyValuePair(undefined, item.name, undefined, CHK_BOX, itemLable.tooltip, item.value));
                      }
                    }
                    if ((!(splitItem[0].startsWith('reportNames-auto')) && splitItem[0] !== 'reportFormat' && splitItem[0] !== 'echannels' && splitItem[0] !== 'primaryAndAditionalUserTraining') || (item === 'primaryAndAditionalUserTraining:guidecheckbox_other')) {
                      accordionFields.length = 1;
                    }
                  }
                } else if (typeof accordionFieldValue === 'object' && !(accordionFieldValue instanceof Array)) {
                  accordionFieldValue = accordionFieldValue.name || ' ';
                  _accordionFieldsJsx.push(this.renderKeyValuePair(undefined, itemLable.name, undefined, CHK_BOX, itemLable.tooltip, itemLable.value));
                } else {
                  if (!accordionFieldValue) {
                    _accordionFieldsJsx.push(this.renderKeyValuePair(undefined, itemLable.name, undefined, UNCHK_BOX, itemLable.tooltip, itemLable.value));
                  }
                }
              } else {
                //Display checkbox labels with unchecked box in case corresponding value is not present.
                if (!accordionFieldValue) {
                  if (splitItem[0] === 'paymentTypes') {
                    _accordionFieldsJsx.push(this.renderKeyValuePair(itemLable.name.toUpperCase(), undefined, undefined, UNCHK_BOX, itemLable.tooltip, itemLable.value));
                  } else {
                    _accordionFieldsJsx.push(this.renderKeyValuePair(undefined, itemLable.name, undefined, UNCHK_BOX, itemLable.tooltip, itemLable.value));
                  }
                }
              }
            } else {
              if (splitForChild[0].startsWith('guideradiobutton')) {
                let accordionFieldValue = formData[splitItem[0]] || undefined;
                if (accordionFieldValue && typeof accordionFieldValue === 'object' && Object.keys(accordionFieldValue).length > 1) {
                  // accordionFieldValue = accordionFieldValue.name || 'No Name Found';
                  _accordionFieldsJsx.push(this.renderKeyValuePair(itemLable.name, accordionFieldValue.name || 'No Name Found'));
                  if (splitItem[0] === 'electronicReportFormats') {
                    let splitAccordionFieldValue = accordionFieldValue.value.split(':');
                    let electronicRptFmtValue = splitAccordionFieldValue[splitAccordionFieldValue.length - 2];
                    //For electronic report format radio button the next field is a map in the array having keys-> full,summary
                    if (accordionFields[1].has(`${splitItem[0]}:${electronicRptFmtValue}`)) {
                      let selectedElectronicRptFmt = accordionFields[1].get(`${splitItem[0]}:${electronicRptFmtValue}`);
                      _accordionFieldsJsx.push(...this.renderAccordionFields(selectedElectronicRptFmt));
                    }
                    accordionFields.length = 1;
                  }
                } else {
                  if (!accordionFieldValue) {
                    _accordionFieldsJsx.push(this.renderKeyValuePair(itemLable.name, ' '));
                  }

                }
              } else {
                _accordionFieldsJsx.push(this.renderKeyValuePair(itemLable.name, item.toUpperCase()));
              }

            }


          } else {
            //for aggregateFormBox, drop down, text box
            //access state accordion data -> this.state.accordionData
            if (!item.startsWith('guidebutton_')) {
              if (item.startsWith('guideaggregateformbox_')) {
                let aggregateFromDetails = this.getAggregateFormComponentsWithLabel(item);
                let componentsArray = aggregateFromDetails.aggFormComponents;
                let aggFromTitle = aggregateFromDetails.aggregateFormTitle;
                let aggFromName = aggregateFromDetails.aggregateFormName;
                let currentAggregateBoxData = formData[item.split('_')[1]] || undefined;
                // if(currentAggregateBoxData && (currentAggregateBoxData.length>0 || Object.keys(currentAggregateBoxData).length>0)){
                _accordionFieldsJsx.push(...this.renderAggregateFormComponent(aggFromTitle, componentsArray, currentAggregateBoxData, aggFromName));
                // }

              } else {
                let _currentDataKey = formData[item.split('_')[1]];
                let accordionFieldLabel = this.getLabelFromAemData(item);
                if (_currentDataKey && (typeof _currentDataKey !== 'boolean')) {
                  switch (typeof _currentDataKey) {
                    case 'string': {
                      let accordionFieldValue = this.getValueFromAccordionData(_currentDataKey, accordionFieldLabel.displayKey);
                      _accordionFieldsJsx.push(this.renderKeyValuePair(accordionFieldLabel.label, accordionFieldValue, false, undefined, accordionFieldLabel.helpText));
                      break;
                    }
                    case 'object': {
                      if (_currentDataKey instanceof Array) {
                        let accordionFieldValue = _currentDataKey[0].name || undefined;
                        if (accordionFieldValue) {
                          _accordionFieldsJsx.push(this.renderKeyValuePair(accordionFieldLabel.label, accordionFieldValue));
                        }
                      } else {
                        let accordionFieldValue = _currentDataKey.name || 'Value Not Found';
                        _accordionFieldsJsx.push(this.renderKeyValuePair(accordionFieldLabel.label, accordionFieldValue));
                      }
                      break;
                    }
                    default: {
                      break;
                    }
                  }
                } else {
                  if (typeof formData[item.split('_')[1]] === 'boolean') {
                    let accordionFieldLabel = this.getLabelFromAemData(item);
                    if (formData[item.split('_')[1]]) {
                      let accordionFieldValue = "Yes";
                      _accordionFieldsJsx.push(this.renderKeyValuePair(accordionFieldLabel.label, accordionFieldValue, false, undefined, undefined, undefined, accordionFieldLabel.para1, accordionFieldLabel.para2));
                    } else if (formData[item.split('_')[1]] === false) {
                      let accordionFieldValue = "No";
                      _accordionFieldsJsx.push(this.renderKeyValuePair(accordionFieldLabel.label, accordionFieldValue));
                      //Resetting the length of accordionFields to 1 so as to prevent subsequent children from rendering
                      accordionFields.length = 1;
                    }
                  } else {
                    //Show labels for fields even when there is no corresponding value present for that label
                    let accordionFieldLabel = this.getLabelFromAemData(item);
                    _accordionFieldsJsx.push(this.renderKeyValuePair(accordionFieldLabel.label, ' '));
                    if (item.split('_')[1] === 'eChannelType' || item.split('_')[1] === 'frequencyOfSubmission') {
                      //Resetting the length of accordionFields to 1 so as to prevent subsequent children from rendering
                      accordionFields.length = 1;
                    }
                  }
                }
              }
            }

          }
          break;
        }
        default: {
          console.log('Unidentified item for ACHAccordion preview: ', item);
        }
      }
    }
    return _accordionFieldsJsx;
  }

  renderAccordionContent = (accordionName, addDetails, newAccounts, echannels) => {
    let _countryName = (addDetails.country.value.split(':')[addDetails.country.value.split(':').length - 2].split('-').join('').toLowerCase());
    //Special handling for UK HSBC Bank Plc as the mapping is same for both UK HSBC and UK HSBC Bank Plc.
    if (_countryName === 'unitedkingdomhsbcbankplc') {
      _countryName = 'unitedkingdomhsbcuk';
    }
    let _accordionFieldsKey = _countryName + '_' + accordionName + `${addDetails.paymentType ? '_' + addDetails.paymentType : ''}`;
    let _accordionFields = accordionFieldsMap.get(_accordionFieldsKey);
    let _accordionJsx = _accordionFields && _accordionFields.length > 0 ? this.renderAccordionFields(_accordionFields) : [];
    return (
      <div className="gdocs-ach-credit-accordion-content-main-div" key={accordionName + getRandomNumber(9999)}>
        {_accordionJsx.length > 0 ? _accordionJsx : ''}
      </div>
    );
  }

  render() {
    let { accordionName, addDetails, newAccounts, echannels } = this.props;
    return (
      <div className="gdocs-ach-credit-accordion-main-div">
        {this.renderAccordionHeading(accordionName)}
        {this.state.accordionAemData ? this.renderAccordionContent(accordionName, addDetails, newAccounts, echannels) : ''}
      </div>
    )
  }
}

AchAccordion.propTypes = {
  accordionName: PropTypes.string.isRequired,
  accordionData: PropTypes.object.isRequired,
  addDetails: PropTypes.object.isRequired,
  accordionAemData: PropTypes.object.isRequired,
  newAccounts: PropTypes.array,
  echannels: PropTypes.array,
  aemStaticData: PropTypes.object,
  taxonomyData: PropTypes.object
}

export default AchAccordion;



// WEBPACK FOOTER //
// ./src/components/CaseBody/PreviewRequest/Child/AchCredit/AchAccordion/AchAccordion.js